module.exports = __webpack_public_path__ + "static/media/img-ovato-brand-new.1d29750d.pdf";